import React, { useState } from "react";
import "./index.scss";
import Dropdown from "../../static/Dropdown/Dropdown";
import { buildDropdowns } from "../DrawSheets/src/utils";
import { Filter } from "../DrawSheets/src/types";
import { dropdownItem } from "../../static/Dropdown/types";
import { Dropdowns, DrawSize, Draw, Selected } from "./types";
import { tournaments } from "../../helpers/errors";
import { checkSelected } from "../../helpers";

interface Props {
  gallery?: any;
  galleryLink?: string;
  galleryLinkText?: string;
  deadline?: string;
  region?: string;
  officialBall?: string;
  tel?: string;
  website?: string;
  address?: string;
  title?: string;
  filters: Filter[];
  drawsData: Draw[];
}

export const DrawSizeFilter = ({
  filters,
  drawsData,
  seniorText
}: {
  filters: Filter[];
  drawsData: Draw[];
  seniorText?: string;
}) => {
  const defaultValues = buildDropdowns(filters, {}).reduce((obj, dd) => {
    obj[dd.dataName] = dd.dropdown[0].value;
    return obj;
  }, {});

  let [selected, setSelected] = useState({
    playerTypeCode: "",
    matchTypeCode: "",
    ageCategoryCode: "",
    juniorRankingType: "",
    ...defaultValues
  });

  const checkValues = (draw: Draw, selected: Selected) => {
    interface arrayItem {
      value: string;
      key: string;
    }
    const keys: string[] = Object.keys(selected);
    const values = keys.reduce((array: arrayItem[], key: string) => {
      if (selected[key]) {
        array.push({
          key,
          value: selected[key]
        });
      }
      return array;
    }, []);
    const flag = values.every(
      ({ key, value }: arrayItem) => draw[key] == value
    );
    return flag;
  };

  let [drawsheets, setDrawSheet] = useState(
    drawsData.filter((d: Draw) => checkValues(d, { ...defaultValues }))[0]
  );

  let [dropDowns, updateDropDowns] = useState(
    buildDropdowns(filters, {}).reverse()
  );

  return (
    <>
      {seniorText ? (
        <p className="tournament-info__dropdown-blurb">{seniorText}</p>
      ) : null}
      <div className="tournament-info__details-item-draw-filters">
        {" "}
        {dropDowns.map((dd: Dropdowns, key: number) => {
          const value =
            dd.dropdown.filter(
              (d: dropdownItem) => d.value === selected[dd.dataName]
            )[0] || dd.dropdown[0];
          return (
            <label
              key={key}
              className="tournament-info__dropdown"
              aria-required="false"
            >
              <p className="tournament-info__dropdown-label">
                Select {dd.filterName}
              </p>
              <Dropdown
                key={key}
                options={dd.dropdown}
                value={value}
                onChange={res => {
                  // reset selections of previous dropdowns in state
                  const updatedSelection = dropDowns.reduce(
                    (obj: any, drop: Dropdowns, key: number) => {
                      const index = dropDowns.indexOf(dd);
                      if (key > index) {
                        obj[drop.dataName] = "";
                      }
                      return obj;
                    },
                    {}
                  );

                  const _selected = {
                    ...selected,
                    [dd.dataName]: res.value,
                    ...updatedSelection
                  };
                  updateDropDowns(
                    buildDropdowns(filters, checkSelected(_selected)).reverse()
                  );
                  setSelected(_selected);
                  setDrawSheet(
                    drawsData.filter((d: Draw) => checkValues(d, _selected))[0]
                  );
                }}
              />
            </label>
          );
        })}
      </div>
      <div className="tournament-info__details-item-draw-results">
        {drawsheets ? (
          <p className="tournament-info__label">Provisional draw size</p>
        ) : null}
        <ul className="tournament-info__dropdown-selection">
          {drawsheets ? (
            drawsheets.drawSizes.map((draw: DrawSize, key: number) => (
              <li key={key}>
                <p>{draw.name}</p>
                <div className="tournament-info__dropdown-selection-value">
                  {draw.value}
                </div>
                <p>Intended start date: {draw.startDate}</p>
                <p>Intended end date: {draw.endDate}</p>
              </li>
            ))
          ) : (
            <p>{tournaments.noResults}</p>
          )}
        </ul>
      </div>
    </>
  );
};

const InfoTournament = ({
  deadline = "",
  region = "",
  officialBall = "",
  tel = "",
  website = "",
  address = "",
  title,
  filters,
  drawsData
}: Props) => {
  return (
    <div className="tournament-info__container">
      {title ? <div className="tournament-info__title">{title}</div> : null}
      <div className="tournament-info__details">
        <div className="tournament-info__details-item tournament-info__details-item--draws">
          <DrawSizeFilter
            filters={filters}
            drawsData={drawsData}
            seniorText="Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
          />
        </div>

        <div className="tournament-info__details-item tournament-info__details-item--draws">
          <p className="tournament-info__label">Draw size: (Juniors)</p>
          <ul>
            <li>
              <h2>Boys</h2>
              <div>
                <p>Singles qualifying: 120</p>
                <p>Singles main draw: 120</p>
                <p>Singles main draw: 120</p>
              </div>
            </li>

            <li>
              <h2>Girls</h2>
              <div>
                <p>Singles qualifying: 120</p>
                <p>Singles main draw: 120</p>
                <p>Singles main draw: 120</p>
              </div>
            </li>
          </ul>
        </div>

        <div className="tournament-info__details-item tournament-info__details-item--draws">
          <p className="tournament-info__label">Draw size: (Juniors)</p>
          <ul className="tournament-info__unordered-list">
            <li>
              <div>
                <p>Singles main draw: 120</p>
                <p>Singles main draw: 120</p>
              </div>
            </li>
            <li>
              <div>
                <p>Singles main draw: 120</p>
                <p>Singles main draw: 120</p>
              </div>
            </li>
          </ul>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">Entry deadline:</p>
          <span className="tournament-info__value">{deadline || "Unset"}</span>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">Withdrawal deadline:</p>
          <span className="tournament-info__value">{deadline || "Unset"}</span>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">
            Main Draw Single Sign-in date/time:
          </p>
          <span className="tournament-info__value">{deadline || "Unset"}</span>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">
            Qualify singles sign-in date/time:
          </p>
          <span className="tournament-info__value">{deadline || "Unset"}</span>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">
            First day of singles qualifying:
          </p>
          <span className="tournament-info__value">{address}</span>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">
            First day of singles main draw:
          </p>
          <span className="tournament-info__value">{address}</span>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">Tournament Director:</p>
          <span className="tournament-info__value">
            {"Tournament director"}
          </span>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">Tournament Director email:</p>
          <span className="tournament-info__value">{region || "Unset"}</span>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">Official ball:</p>
          <span className="tournament-info__value">
            {officialBall || "Unset"}
          </span>
        </div>
      </div>

      <hr />

      <div className="tournament-info__details--blurb">
        <div>
          <h2>Looking for more info?</h2>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quaerat,
            rem quam similique fugit accusamus corrupti quasi ipsam minus dolor
            expedita magni possimus dolorum sunt nemo? Nobis deleniti quam
            incidunt quae!
          </p>
        </div>
        <div className="tournament-info__cta-container">
          <a className="btn">Login to IPIN</a>
          <a className="btn">What is IPIN?</a>
        </div>
      </div>

      <hr />

      <div className="tournament-info__title">Venue information</div>
      <div className="tournament-info__details">
        <div className="tournament-info__details-item">
          <p className="tournament-info__label">Name of venue:</p>
          <span className="tournament-info__value">{"Unset"}</span>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">Venue address:</p>
          <span className="tournament-info__value">{address}</span>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">Venue telephone:</p>
          <span className="tournament-info__value">
            <a
              href={`tel:${tel || "Unset"}`}
              className="tournament-info__value"
            >
              {tel || "Unset"}
            </a>
          </span>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">Venue Website:</p>
          <a
            target="_blank"
            href={`${website || "Unset"}`}
            className="tournament-info__value"
          >
            {website || "Unset"}
          </a>
        </div>

        <div className="tournament-info__details-item">
          <p className="tournament-info__label">
            Order of play: (
            <a
              target="_blank"
              href={`${website || "Unset"}`}
              className="tournament-info__value external"
            >
              View maps in Google Maps
            </a>
            )
          </p>
          <a
            target="_blank"
            href={`${website || "Unset"}`}
            className="tournament-info__value external"
          >
            {website || "Unset"}
          </a>
        </div>
      </div>

      <hr />

      <div className="tournament-info__details--blurb">
        <div>
          <h2>Nation Association</h2>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quaerat,
            rem quam similique fugit accusamus corrupti quasi ipsam minus dolor
            expedita magni possimus dolorum sunt nemo? Nobis deleniti quam
            incidunt quae!
          </p>
        </div>
        <div className="tournament-info__cta-container">
          <a
            href="/en/about-us/organisation/member-associations"
            className="btn"
          >
            National Association Directory
          </a>
        </div>
      </div>
    </div>
  );
};

export default InfoTournament;
